// extracted by mini-css-extract-plugin
export default {"container":"UnauthorizedScopePage_container__vSE5i","message_container":"UnauthorizedScopePage_message_container__BjITf","message":"UnauthorizedScopePage_message__S0uRO"};